// hooks/useUpcomingEvents.js
import { useQuery } from "@tanstack/react-query";
import { fetchUpcomingEventsAPI } from "../api/upcomingEvents";

export const useUpcomingEvents = () => {
  return useQuery({
    queryKey: ["upcomingEvents"],
    queryFn: fetchUpcomingEventsAPI,
    staleTime: 5 * 60 * 1000, // 5 minutes
    gcTime: 10 * 60 * 1000, // 10 minutes (formerly cacheTime)
    refetchOnWindowFocus: false,
    retry: 2,
  });
};